import {DistrictMapLegendItem} from "../../../utils/dynamic_district_map_legend_values";
import {IRegionGeometry} from "./map/api/charts_regions_api";
import {IOsmDistrictPolygon} from "./map/types/osm_district_polygon";
import OpenStreetMapBrowserOnly from "./OpenStreetMapBrowserOnly";

interface LazyOpenStreetMapProps {
    center?: [number, number];
    zoom?: number;
    height?: string;
    className?: string;
    markers?: Array<{
        id: string | number;
        coords: [number, number];
        popup?: string;
        onClick?: () => void;
        icon?: {
            url: string;
            sizes: [number, number];
        };
    }>;
    scrollWheelZoom?: boolean;
    fitBounds?: boolean;
    maxZoom?: number;
    regionsMapSlug?: string;
    regionsMapParentId?: number;
    regionsMapChildType?: number;
    regionsMapRegionId?: number;
    districtValuesBySlug?: Record<string, number>;
    districtStatsCitySlug?: string;
    addedMetricLabel?: string;
    locale?: string;
    legendColors?: string[];
    legendItems?: DistrictMapLegendItem[];
    legendType?: "quantitative" | "pricing";
    districtMetricFormat?: "default" | "percent";
    legendSize?: "default" | "large" | "xlarge";
    districtPolygonTooltip?: boolean;
    districtDrillDownEnabled?: boolean;
    onDistrictPolygonClick?: (district: IOsmDistrictPolygon) => void;
    cityOutlineMetric?: boolean;
    regionGeometry?: IRegionGeometry | null;
}

export const LazyOpenStreetMap = (props: LazyOpenStreetMapProps) => {
    return <OpenStreetMapBrowserOnly {...props} />;
};
